<template>
    <div>
        <h3>E106 Compliance Request</h3>
        <loader v-if="isLoading" />
        <div class="wrapper">
            <tabs>
                <tab header="Request">
                    <projectHeader v-bind:project="project"></projectHeader>
                    <fieldset :disabled="formDisabled">
                        <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="compliance">
                            <div class="form-group">
                                <div class="col-md-3"><h4 style="margin-bottom: 0px;">Project Description</h4></div>
                                <div class="col-md-9">
                                    <textarea class="form-control" rows="2" v-model="complianceDto.projectDescription" v-validate="'required'"/>
                                </div>
                            </div>
                            <h4>Property Information</h4>
                            <div class="form-group">
                                <div class="col-md-4">
                                    <button name="addPropertyInfo" class="btn btn-primary" :disabled="isNew" v-on:click="addNewPropertyInfo()">Add Property Information</button>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <v-client-table :data="propertyInfoGridSpec.tableData" :columns="propertyInfoGridSpec.columns" :options="propertyInfoGridSpec.options">
                                        <template slot="edit" slot-scope="props">
                                            <div style="text-align: center;">
                                                <a class="fa fa-edit" style="font-size: 18px;" v-on:click="editPropertyInformation(props.row)"></a>
                                            </div>
                                        </template>
                                        <template slot="delete" slot-scope="props">
                                            <div style="text-align: center;" v-if="!formDisabled">
                                                <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deletePropertyInformation(props.row.e106compliancePropertyInformationId)"></a>
                                            </div>
                                        </template>
                                    </v-client-table>
                                </div>
                            </div>
                            <h4>PLSS Locations</h4>
                            <div class="form-group">
                                <div class="col-md-4">
                                    <button name="button3" :disabled="isNew" class="btn btn-primary" v-on:click="showSectionModal()">Add PLSS Locations</button>
                                    <modal title="Add Sections(s)" effect="fade/zoom" :value="sectionModalShow">
                                        <div slot="modal-header" class="modal-header">
                                            <h4 class="modal-title">Add PLSS Locations</h4>
                                        </div>
                                        <div slot="modal-body" class="modal-body">
                                            <plssComponent v-on:savePlss="savePlssE106Compliance" ref="plssComponent" v-bind:showTitle="false">
                                            </plssComponent>
                                        </div>
                                        <div slot="modal-footer" class="modal-footer">
                                            <button type="button" class="btn btn-default" @click="closeSectionModal" style="margin-bottom: 0px;">Exit</button>
                                        </div>
                                    </modal>
                                </div>
                            </div>
                            <div>
                                <div v-show="plssLocationGridSpec.tableData.length > 0">
                                    <v-client-table :data="plssLocationGridSpec.tableData" :columns="plssLocationGridSpec.columns" :options="plssLocationGridSpec.options">
                                    <template slot="delete" slot-scope="props">
                                        <div style="text-align: center;" v-if="!formDisabled">
                                            <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deletePlssLocation(props.row.e106compliancePlssLocationId)"></a>
                                        </div>
                                    </template>
                                    </v-client-table>
                                </div>
                            </div>
                            <h4>Land Information</h4>
                            <div class="form-group">
                                <label class="col-md-3 control-label text-label">Description of Current Land Use</label>
                                <div class="col-md-9">
                                    <textarea class="form-control" rows="6" v-model="complianceDto.currentLandUse" v-validate="'required'"/>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-3 control-label text-label">Nature of Any Previous Disturbances</label>
                                <div class="col-md-9">
                                    <textarea class="form-control" rows="6" v-model="complianceDto.previousDisturbances" v-validate="'required'"/>
                                </div>
                            </div>
                            <div id="publicE106Contact" v-if="isPublicSubmission">
                                <hr class="form-group" style="border:solid 1px #cccccc;" />
                                <h4>Contact</h4>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Submitter First Name</label>
                                    <div class="col-md-5">
                                        <input name="submitterFirstName" type="text" class="form-control" v-model="complianceDto.submitterFirstName" placeholder="Submitter First Name" />
                                    </div>
                                </div>
                                <div class="form-group" >
                                    <label class="col-md-3 control-label">Submitter Last Name</label>
                                    <div class="col-md-5">
                                        <input name="submitterLastName" type="text" class="form-control" v-model="complianceDto.submitterLastName" placeholder="Submitter Last Name" />
                                    </div>
                                </div>
                                <div class="form-group" >
                                    <label class="col-md-3 control-label">Submitter Email</label>
                                    <div class="col-md-5">
                                        <input name="submitterEmail" type="text" class="form-control" v-model="complianceDto.submitterEmail" placeholder="user@example.com" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Submitter Phone Number</label>
                                    <div class="col-md-5">
                                        <input name="submitterPhone" type="tel" class="form-control" v-model="complianceDto.submitterPhone" placeholder="123-45-6789" />
                                    </div>
                                </div>
                                <hr class="form-group" style="border:solid 1px #cccccc;" />
                            </div>
                            <div class="form-group" style="margin-top:10px">
                                <div class="col-md-2 col-md-offset-2" v-if="!formDisabled">
                                    <button class="btn btn-primary" v-on:click="saveCompliance">{{ isNew ? "Create" : "Save" }}</button>
                                </div>
                            </div>
                        </form>
                    </fieldset>
                    <modal2 ref="propertyInfoModal">
                        <div slot="header" class="row">
                            <h3 class="pull-left">Property Information</h3>
                            <button class="btn pull-right" v-on:click="$refs['propertyInfoModal'].close()">X</button>
                        </div>
                        <div slot="body">
                            <fieldset :disabled="formDisabled">
                                <div class="form-group">
                                        <label class="col-md-3 control-label text-label">Street Address</label>
                                        <div class="col-md-6">
                                            <input type="text" class="form-control" v-model="selectedPropertyInfo.streetAddress" v-validate="'required'">
                                        </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label text-label">City</label>
                                    <div class="col-md-3">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.city" v-validate="'required'">
                                    </div>
                                    <label class="col-md-1 control-label text-label">County</label>
                                    <div class="col-md-2">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.county" v-validate="'required'">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label text-label">Zip Code</label>
                                    <div class="col-md-2">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.zipCode" v-validate="'required'">
                                    </div>
                                    <label class="col-md-1 control-label text-label">Lot</label>
                                    <div class="col-md-1">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.lot" v-validate="'required'">
                                    </div>
                                    <label class="col-md-1 control-label text-label">Block</label>
                                    <div class="col-md-1">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.block" v-validate="'required'">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label text-label">Date of Construction</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.constructionDate">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label text-label">Dates of Additions/Modifications</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="selectedPropertyInfo.additionsModificationsDates">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label text-label">Proposed Changes and Brief History of the Building</label>
                                    <div class="col-md-9">
                                        <textarea class="form-control" rows="6" v-model="selectedPropertyInfo.proposedChangesBriefHistory" v-validate="'required'"/>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div slot="footer">
                            <div class="col-md-1" v-if="!formDisabled">
                                <button type="button" class="btn btn-primary" v-on:click="savePropertyInformation()" style="margin-bottom: 0px;">Save</button>
                            </div>
                        </div>
                    </modal2>
                </tab>
                <tab header="Documents" :disabled="isNew">
                    <projectHeader v-bind:project="project"></projectHeader>
                    <div style="margin-top: 20px;">
                        <documents v-if="!isNew" :parentId="e106complianceId" :formDisabled="formDisabled" ref="documents"></documents>
                    </div>
                    <div>
                        <div style="margin-top: 20px;" v-if="!isNew">
                            <mediaLetter :mediaTypeId="mediaTypeIdE106Letter" :parentId="e106complianceId"></mediaLetter>
                        </div>
                    </div>
                </tab>
                <tab header="Workflow" :disabled="isNew">
                    <projectHeader v-bind:project="project"></projectHeader>
                    <div style="margin-top: 20px;">
                        <workflow :workflowId="e106complianceWorkflowId" :parentId="e106complianceId" ref="workflow" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></workflow>
                    </div>
                    <div v-if="checkShpoRole" style="margin-top: 20px;">
                        <quickLetter :projectId="project ? project.projectId : null" :e106complianceId="e106complianceId"
                        :mediaTypeId="mediaTypeIdE106Letter" :parentId="e106complianceId"></quickLetter>
                    </div>
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import e106ComplianceService from '@/services/e106ComplianceService'
import e106CompliancePropertyInformationService from '@/services/e106CompliancePropertyInformationService'
import projectService from '@/services/projectService'
import workflowService from '@/services/workflowService'
import mediaService from '@/services/mediaService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'

import projectHeader from '@/components/ProjectHeader'
import loader from '@/components/Loader'
import documents from '@/components/e106ComplianceDocuments'
import workflow from '@/components/Workflow'
import mediaLetter from '@/components/MediaLetter'
import quickLetter from '../components/QuickLetter.vue'
import { tab, tabs, modal } from 'vue-strap'
import modal2 from '@/components/Modal.vue'
import plssComponent from '../components/PlssComponent.vue'

export default {
    name: 'E106Compliance',
    components: {
        projectHeader,
        loader,
        workflow,
        mediaLetter,
        quickLetter,
        tabs,
        tab,
        modal,
        documents,
        plssComponent,
        modal2
    },
    computed: {
        isNew: function () {
            return !this.e106complianceId
        },
        e106complianceWorkflowId: function () {
            return workflowService.WorkflowEnum.E106Compliance
        },
        e106complianceId: function () {
            return this.$route.params.e106complianceId
        },
        mediaTypeIdE106Letter: function () {
            return mediaService.mediaType.E106ComplianceLetter
        },
                // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        checkShpoRole: function () {
            var shpoRoleList = roleService.ShpoRoleList
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        formDisabled: function () {
            return this.isShpoReadOnly
        },
        isPublicSubmission: function () {
            return this.complianceDto.createdBy === 'Public'
        }
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            complianceDto: {},
            project: {},
            plssLocationGridSpec: {
                columns: ['meridianDescription', 'township', 'townshipDirection', 'range', 'rangeDirection', 'section', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    filterable: false,
                    dateColumns: ['createdDate', 'modifiedDate'],
                    headings: {
                        townshipDirection: 'Township Dir.',
                        rangeDirection: 'Range Dir.',
                        meridianDescription: 'Meridian',
                        delete: 'Delete'
                    }
                }
            },
            propertyInfoGridSpec: {
                columns: ['edit', 'streetAddress', 'city', 'county', 'zip', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    filterable: false,
                    dateColumns: ['createdDate', 'modifiedDate'],
                    headings: {
                        streetAddress: 'Street Address',
                        delete: 'Delete'
                    }
                }
            },
            selectedPropertyInfo: {
                e106complianceId: this.e106complianceId
            },
            sectionModalShow: false,
            sectionModalSaveReady: false
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'E106 Compliance', message)
        },
        createForm () {
            this.complianceDto = {
                projectId: this.$route.query.projectId
            }
        },
        loadCompliance (e106complianceId) {
            return e106ComplianceService.get(this.$http, e106complianceId).then(result => {
                this.complianceDto = result.data
                return result
            })
        },
        loadProject () {
            if (!this.complianceDto.projectId) {
                this.log('New request, looking for projectId from route query')
                if (this.$route.query.projectId) {
                    return projectService.get(this.$http, this.$route.query.projectId).then(result => {
                        if (result.data) {
                            this.log('Found project: ' + result.data.name)
                            this.project = result.data
                            return result
                        } else {
                            this.log('Cannot find project with project ID: ' + this.$route.query.projectId)
                            return result
                        }
                    })
                } else {
                    this.log('No project')
                    return
                }
            }
            this.log('looking for project: ' + this.complianceDto.projectId)
            return projectService.get(this.$http, this.complianceDto.projectId).then(result => {
                if (result.data) {
                    this.log('Found project: ' + result.data)
                    this.project = result.data
                    return result
                }
            })
        },
        loadData () {
            this.isLoading = true
            if (!this.e106complianceId) {
                this.loadProject().then(x => {
                    this.isLoading = false
                    return this.createForm()
                })
            } else {
                Promise.all([this.loadCompliance(this.e106complianceId)]).then(x => {
                    this.loadProject().then(y => {
                        this.$refs.workflow.loadData()
                        this.loadE106CompliancePlssLocationResultList()
                        this.loadE106CompliancePropertyInformation()
                        this.isLoading = false
                        return y
                    })
                })
            }
        },
        saveCompliance () {
            this.isLoading = true
            e106ComplianceService.put(this.$http, this.complianceDto).then(result => {
                this.log('new complianceId = ' + result.data.id)
                this.$router.push('/E106Compliance/' + result.data.id)
                this.loadData()
            })
        },
        showSectionModal () {
            this.sectionModalShow = true
        },
        closeSectionModal () {
            this.sectionModalShow = false
        },
        loadE106CompliancePlssLocationResultList () {
            loggingService.log(this.isDebug, 'E106Compliance', 'loadE106CompliancePlssLocationResultList')
            e106ComplianceService.listE106CompliancePlssLocationResultDto(this.$http, this.e106complianceId).then(response => {
                this.plssLocationGridSpec.tableData = response.data
            })
        },
        savePlssE106Compliance () {
            var plss = this.$refs['plssComponent'].plssData

            e106ComplianceService.putPlss(this.$http, this.e106complianceId, plss).then(response => {
                loggingService.log(this.isDebug, 'E106Compliance', 'savePlssE106Compliance - complete')
                this.sectionModalShow = false

                this.loadE106CompliancePlssLocationResultList()
            })
        },
        deletePlssLocation (e106compliancePlssLocationId) {
            loggingService.log(this.isDebug, 'E106Compliance', 'delete plss Location :' + e106compliancePlssLocationId)
            e106ComplianceService.deletePlssLocation(this.$http, e106compliancePlssLocationId).then(response => {
                this.loadE106CompliancePlssLocationResultList()
            })
        },
        loadE106CompliancePropertyInformation () {
            loggingService.log(this.isDebug, 'E106Compliance', 'loadE106CompliancePropertyInformation')
            e106CompliancePropertyInformationService.search(this.$http, this.e106complianceId).then(response => {
                this.propertyInfoGridSpec.tableData = response.data
            })
        },
        resetPropertyInfo () {
            this.selectedPropertyInfo = {
                e106complianceId: this.e106complianceId
            }
        },
        addNewPropertyInfo () {
            this.resetPropertyInfo()
            this.$refs['propertyInfoModal'].open()
        },
        savePropertyInformation () {
            e106CompliancePropertyInformationService.put(this.$http, this.selectedPropertyInfo).then(response => {
                this.resetPropertyInfo()
                this.loadE106CompliancePropertyInformation()
                this.$refs['propertyInfoModal'].close()
            })
        },
        editPropertyInformation (propertyInformation) {
            this.selectedPropertyInfo = propertyInformation
            this.$refs['propertyInfoModal'].open()
        },
        deletePropertyInformation (e106compliancePropertyInformationId) {
            e106CompliancePropertyInformationService.remove(this.$http, e106compliancePropertyInformationId).then(response => {
                this.loadE106CompliancePropertyInformation()
            })
        },
        workflowOnSubmitSuccess (submitValidationResult) {
            //trigger media letter refresh if letter gen is triggered
            if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
        }
    }
}
</script>
<style>
    .form-horizontal .form-group {
        margin-left: 0px;
    }
</style>




// WEBPACK FOOTER //
// E106Compliance.vue?f3ad574e